import { Collection } from 'modules/core/lib/mobx-rest'

import WorkArea from 'modules/shift_management/store/api/models/WorkArea'

class WorkAreas extends Collection<WorkArea> {
  get cacheKey(): string {
    return 'workAreas'
  }
  model() {
    return WorkArea
  }
}

const singleton: WorkAreas = new WorkAreas()

export default singleton
